"use client";

import { Fragment } from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import VisitCounter from "../common/VisitCounter";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import Link from "next/link";
import Image from "next/image";
import { useAppDispatch, useAppSelector } from "@/_hooks/hooks";
import { ISettings } from "@/store/homeSlice";

export default function Footer() {
  const dispatch = useAppDispatch();
  const SettingList = useAppSelector((state) => state.home.SettingList);
  const PackageList = useAppSelector((state) => state.package.PackageList);
  const SOUPackageList = useAppSelector(
    (state) => state.package.SOUPackageList,
  );
  const TicketList = useAppSelector((state) => state.ticket.TicketList);
  const HotelList = useAppSelector((state) => state.hotel.HotelList);
  const Settings: Record<string, ISettings> = SettingList?.reduce(
    (acc, item) => {
      acc[item?.SettingKey] = item;
      return acc;
    },
    {} as Record<string, ISettings>,
  );

  const PhoneNo = Settings?.["PhoneNo"]?.SettingValue;
  const PhoneNo2 = Settings?.["PhoneNo2"]?.SettingValue;
  const PhoneNo3 = Settings?.["PhoneNo3"]?.SettingValue;
  const EmailID = Settings?.["EmailID"]?.SettingValue;
  const EmailID2 = Settings?.["EmailID2"]?.SettingValue;
  const EmailID3 = Settings?.["EmailID3"]?.SettingValue;
  const Address = Settings?.["Address"]?.SettingValue;
  const Address2 = Settings?.["Address2"]?.SettingValue;
  const Address3 = Settings?.["Address3"]?.SettingValue;
  const AddressMap = Settings?.["AddressMap"]?.SettingValue;
  const AddressMap2 = Settings?.["AddressMap2"]?.SettingValue;
  const AddressMap3 = Settings?.["AddressMap3"]?.SettingValue;
  const AddressIframe = Settings?.["AddressIframe"]?.SettingValue;
  const BusinessHours = Settings?.["BusinessHours"]?.SettingValue;
  const BusinessHours2 = Settings?.["BusinessHours2"]?.SettingValue;
  const FacebookLink = Settings?.["FacebookLink"]?.SettingValue;
  const InstaLink = Settings?.["InstaLink"]?.SettingValue;
  const XLink = Settings?.["XLink"]?.SettingValue;
  const LinkedInLink = Settings?.["LinkedInLink"]?.SettingValue;
  const YoutubeLink = Settings?.["YoutubeLink"]?.SettingValue;
  const CompanyName = Settings?.["CompanyName"]?.SettingValue;

  const quickLinks = [
    { name: "Home", href: "/" },
    { name: "About Us", href: "/about" },
    { name: "Blogs", href: "/blogs" },
    { name: "Contact", href: "/contact" },
    { name: "Hotels", href: "/sou-hotels" },
    { name: "Tickets", href: "/sou-tickets" },
    { name: "Gallery", href: "/gallery" },
    { name: "Attractions", href: "/attractions" },
  ];

  return (
    <>
      <div className="footer-links">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="content_section">
            <p className="content_section_text">
              <strong>SOU Tickets : </strong>
              {TicketList?.filter((ticket: any) => ticket.BookingURL)?.map(
                (ticket: any, index: number, arr: any[]) => (
                  <Fragment key={index}>
                    <Link href={`/sou-tickets/${ticket?.TicketURL}`}>
                      {ticket?.Title}
                    </Link>
                    {arr?.length !== index + 1 && <span>|</span>}
                  </Fragment>
                ),
              )}
            </p>
            <p className="content_section_text">
              <strong>SOU Packages : </strong>
              {SOUPackageList?.map((pkg: any, index: number, arr: any[]) => (
                <Fragment key={index}>
                  <Link
                    href={`/sou-packages/${pkg?.PackageURL}`}
                    rel="noopener noreferrer"
                  >
                    {pkg?.Title}
                  </Link>
                  {arr?.length !== index + 1 && <span>|</span>}
                </Fragment>
              ))}
            </p>
            {/* <p className="content_section_text">
              <strong>Gujarat Packages : </strong>
              {PackageList?.map((pkg: any, index: number, arr: any[]) => (
                <Fragment key={index}>
                  <Link
                    href={`/gujarat-packages/${pkg?.TourURL}`}
                    rel="noopener noreferrer"
                  >
                    {pkg?.TourName}
                  </Link>
                  {arr?.length !== index + 1 && <span>|</span>}
                </Fragment>
              ))}
            </p> */}
          </div>
        </div>
      </div>

      <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            {/* Brand Section */}
            <div>
              <div className="bg-white backdrop-blur-sm p-4 rounded-xl inline-block mb-6 border border-white/20">
                <Link href="/">
                  <Image
                    src="/logo.jpg"
                    alt="Statue of Unity"
                    width={220}
                    height={98}
                    className="h-16 w-auto brightness-110 contrast-125"
                  />
                </Link>
              </div>
              <p className="text-gray-400 mb-6">
                Your trusted partner for unforgettable Statue of Unity
                experiences. Luxury stays, curated tours, and seamless booking.
              </p>
              <VisitCounter />
              <div className="flex gap-4">
                {FacebookLink && (
                  <Link
                    href={FacebookLink}
                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-gradient-to-r hover:from-orange-500 hover:to-amber-500 flex items-center justify-center transition-all duration-300"
                  >
                    <FaFacebook className="w-5 h-5" />
                  </Link>
                )}
                {InstaLink && (
                  <Link
                    href={InstaLink}
                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-gradient-to-r hover:from-orange-500 hover:to-amber-500 flex items-center justify-center transition-all duration-300"
                  >
                    <FaInstagram className="w-5 h-5" />
                  </Link>
                )}
                {XLink && (
                  <Link
                    href={XLink}
                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-gradient-to-r hover:from-orange-500 hover:to-amber-500 flex items-center justify-center transition-all duration-300"
                  >
                    <FaTwitter className="w-5 h-5" />
                  </Link>
                )}
                {LinkedInLink && (
                  <Link
                    href={LinkedInLink}
                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-gradient-to-r hover:from-orange-500 hover:to-amber-500 flex items-center justify-center transition-all duration-300"
                  >
                    <FaLinkedin className="w-5 h-5" />
                  </Link>
                )}
                {YoutubeLink && (
                  <Link
                    href={YoutubeLink}
                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-gradient-to-r hover:from-orange-500 hover:to-amber-500 flex items-center justify-center transition-all duration-300"
                  >
                    <FaYoutube className="w-5 h-5" />
                  </Link>
                )}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-xl mb-6 font-bold">Quick Links</h3>
              <ul className="space-y-3">
                {quickLinks.map((link: any, index: number) => (
                  <li key={index}>
                    <Link
                      href={link.href}
                      className="text-gray-400 hover:text-orange-500 transition-colors duration-300"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Popular Packages */}
            <div>
              <h3 className="text-xl mb-6 font-bold">Popular Hotels</h3>
              <ul className="space-y-3">
                {HotelList?.slice(0, 8).map((hotel: any, index: number) => (
                  <li key={index}>
                    <Link
                      href={`/sou-hotels/${hotel?.URL}`}
                      className="text-gray-400 hover:text-orange-500 transition-colors duration-300"
                    >
                      {hotel?.HotelName}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-xl mb-6 font-bold">Contact Us</h3>
              <ul className="space-y-4">
                <h6 className="text-md mb-2 font-bold text-amber-600">
                  {CompanyName}
                </h6>
                <li className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-orange-500 flex-shrink-0 mt-1" />
                  <div className="text-gray-400">
                    {Address && (
                      <p className="hover:text-orange-500">
                        <Link href={AddressMap || "#"} target="_blank">
                          {Address}
                        </Link>
                      </p>
                    )}
                    {Address2 && (
                      <p className="hover:text-orange-500 mt-3">
                        <Link href={AddressMap2 || "#"} target="_blank">
                          {Address2}
                        </Link>
                      </p>
                    )}
                    {Address3 && (
                      <p className="hover:text-orange-500 mt-3">
                        <Link href={AddressMap3 || "#"} target="_blank">
                          {Address3}
                        </Link>
                      </p>
                    )}
                  </div>
                </li>
                <li className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-orange-500 flex-shrink-0" />
                  <div>
                    {PhoneNo && (
                      <Link
                        href={`tel:${PhoneNo}`}
                        className="text-gray-400 hover:text-orange-500 transition-colors"
                      >
                        {PhoneNo}
                      </Link>
                    )}
                    {PhoneNo2 && (
                      <Link
                        href={`tel:${PhoneNo2}`}
                        className="text-gray-400 hover:text-orange-500 transition-colors"
                      >
                        {PhoneNo2}
                      </Link>
                    )}
                    {PhoneNo3 && (
                      <Link
                        href={`tel:${PhoneNo3}`}
                        className="text-gray-400 hover:text-orange-500 transition-colors"
                      >
                        {PhoneNo3}
                      </Link>
                    )}
                  </div>
                </li>
                <li className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-orange-500 flex-shrink-0" />
                  <div>
                    {EmailID && (
                      <Link
                        href={`mailto:${EmailID}`}
                        className="text-gray-400 hover:text-orange-500 transition-colors"
                      >
                        {EmailID}
                      </Link>
                    )}
                    {EmailID2 && (
                      <Link
                        href={`mailto:${EmailID2}`}
                        className="text-gray-400 hover:text-orange-500 transition-colors"
                      >
                        {EmailID2}
                      </Link>
                    )}
                    {EmailID3 && (
                      <Link
                        href={`mailto:${EmailID3}`}
                        className="text-gray-400 hover:text-orange-500 transition-colors"
                      >
                        {EmailID3}
                      </Link>
                    )}
                  </div>
                </li>
              </ul>

              {(BusinessHours || BusinessHours2) && (
                <div className="mt-6">
                  <h4 className="text-sm mb-3 text-gray-300 font-semibold">
                    Business Hours
                  </h4>
                  {BusinessHours && (
                    <p className="text-gray-400 text-sm">{BusinessHours}</p>
                  )}
                  {BusinessHours2 && (
                    <p className="text-gray-400 text-sm">{BusinessHours2}</p>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* SEO Keywords Section */}
          {/* <div className="border-t border-gray-800 pt-8 mb-8">
            <h3 className="text-xl mb-4 font-bold">Explore More</h3>
          <div className="flex flex-wrap gap-3">
            {experiences.map((exp) => (
              <a
                key={exp}
                href="#"
                className="px-4 py-2 bg-white/5 rounded-lg hover:bg-gradient-to-r hover:from-orange-500/20 hover:to-amber-500/20 text-sm text-gray-400 hover:text-white transition-all duration-300"
              >
                {exp}
              </a>
            ))}
          </div>
              <div className="flex gap-6 text-sm text-gray-400 justify-center md:justify-end">
                <Link
                href="/privacy-policy/"
                  target="_blank"
                  className="hover:text-orange-500 transition-colors duration-300"
                >
                  Privacy Policy
                </Link>{" "}
                |
                <Link
                href="/terms-conditions/"
                  target="_blank"
                  className="hover:text-orange-500 transition-colors duration-300"
                >
                  Terms & Conditions
                </Link>
              <Link href="/" className="hover:text-orange-500 transition-colors duration-300">
                Cancellation Policy
              </Link>
            </div>
          </div> */}

          {/* Bottom Bar */}
          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-gray-400 text-sm text-center md:text-left">
                © {new Date().getFullYear()} Aalpine - Statue of Unity Tours.
                All rights reserved.
              </p>
              <div className="flex gap-6 text-sm justify-center md:justify-end">
                <Link
                  className="text-white/60 transition-colors"
                  href="https://aseuminfotech.com/"
                  target="_blank"
                >
                  Developed by{" "}
                  <span className="text-white hover:text-orange-500 transition-colors">
                    ASEUM INFOTECH
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
